import './photoTips.scss';
import React, { useState } from 'react';
import { translateText } from '../../../getTranslationsMyProfileUploadDocumentation';
import idRoundOk from 'assets/icons/icon-id-round-ok.svg';
import idRoundShadow from 'assets/icons/icon-id-round-shadow.svg';
import idRoundKo from 'assets/icons/icon-id-round-ko.svg';
import arrowUp from 'assets/icons/icon-arrow-up.svg';
import arrowDown from 'assets/icons/icon-arrow-down.svg';
import { recordLinkV2 } from "utilities/tagging"

const photoInstructions = [
  {
    instructionText: 'photoTips_01',
    icon: idRoundOk,
  },
  {
    instructionText: 'photoTips_02',
    icon: idRoundShadow,
  },
  {
    instructionText: 'photoTips_03',
    icon: idRoundKo,
  },
];

export const PhotoTips = ({processSelected}) => {
  const [showTipContent, setShowTipContent] = useState(false);

  const handleClick = () => {
      setShowTipContent(prevState => !prevState)
      recordLinkV2({
          categoriaEvento: `documentos/subida de documentacion/${processSelected}`,
          eventAction: showTipContent ? "closeDropdown" : "openDropdown",
          etiquetaEvento: "consejos fotos validas",
      })
  };

  return (
      <div className="tip-container">
          <div className="tip-title">
              <h5>{translateText('tipsPhotosTitle')}</h5>
              <button onClick={handleClick}>
                  {showTipContent ? (
                      <img src={arrowUp} alt="arrow up" />
          ) : (
              <img src={arrowDown} alt="arrow down" />
          )}
              </button>
          </div>
          <div className={`tip-list ${!showTipContent && 'hiddenTip'}`}>
              {photoInstructions.map(({ instructionText, icon }, index) => (
                  <div className={'tip-list-item'} key={index}>
                      <img src={icon} alt={instructionText} />
                      <p>{translateText(instructionText)}</p>
                  </div>
        ))}
          </div>
      </div>
  );
};
